import * as React from 'react';
import { debounce } from 'lodash';
import { searchUser } from 'rest/user';
import type { State } from 'state';
import type { MultiUserPickerProps, MultiUserPickerOption } from './multi-user-picker-dumb';
import { MultiUserPickerDumb } from './multi-user-picker-dumb';

interface Props extends MultiUserPickerProps {
	portalId: number;
	fieldConfigId: string;
	canAddUserByEmailAddress: boolean;
}

type FinalProps = Omit<Props, 'loadOptions' | 'doInitialSearch'>;

export default class MultiUserPicker extends React.PureComponent<FinalProps, State> {
	loadOptions = (inputValue: string, callback: (options: MultiUserPickerOption[]) => void) => {
		// Disabling existing violations, should be fixed when revisited.
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		this.fetchUserDebounced(inputValue, callback);
	};

	fetchUsers = (inputValue: string, callback: (options: MultiUserPickerOption[]) => void) => {
		return searchUser({
			fieldName: this.props.id,
			query: inputValue,
			portalId: this.props.portalId,
			fieldConfigId: this.props.fieldConfigId,
		})
			.map((response) =>
				response.map((user) => ({
					value: user.id,
					label: user.displayName,
					iconUrl: user.avatar,
					email: user.emailAddress,
				})),
			)
			.toPromise()
			.then(callback);
	};

	fetchUserDebounced = debounce(this.fetchUsers, 400);

	render() {
		const { portalId, canAddUserByEmailAddress, ...props } = this.props;
		return (
			<MultiUserPickerDumb
				{...props}
				loadOptions={this.loadOptions}
				doInitialSearch
				canAddUserByEmailAddress={canAddUserByEmailAddress}
			/>
		);
	}
}
